interface ScreenStubProps {
  title: string;
  prdSection: string;
  description: string;
  routeParam?: { name: string; value: string | undefined };
  status?: 'stub' | 'partial' | 'live';
  children?: React.ReactNode;
}

export default function ScreenStub({
  title,
  prdSection,
  description,
  routeParam,
  status = 'stub',
  children,
}: ScreenStubProps) {
  return (
    <section className="px-10 py-8" data-testid={`screen-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
      <header className="max-w-5xl">
        <p className="label-small-caps text-gold-bright">PRD {prdSection}</p>
        <h1 className="heading-display text-3xl text-cream mt-2">{title}</h1>
        <p className="font-serif text-cream-soft mt-3 text-base">{description}</p>
        {routeParam ? (
          <p className="font-mono text-xs text-gold-dim mt-2">
            {routeParam.name}: {routeParam.value ?? '(unset)'}
          </p>
        ) : null}
        <span
          className={`mt-4 inline-flex pill-cream ${
            status === 'live'
              ? 'border-mint/60 text-mint'
              : status === 'partial'
                ? 'border-gold-bright/60 text-gold-bright'
                : ''
          }`}
        >
          {status === 'live'
            ? 'Live'
            : status === 'partial'
              ? 'Partial. Continues in later epic.'
              : 'Stub. Will land in a later epic.'}
        </span>
      </header>
      {children ? <div className="mt-8 max-w-5xl">{children}</div> : null}
    </section>
  );
}
